export default {
    uploadFile: 'Upload File',
    videos: 'Videos',
    photos: 'Photos',
    removeFile: 'Do you want to remove this file?',
    fileAdded: 'File has been added',
    fileRemoved: 'File has been removed',
}
